module.exports = __webpack_public_path__ + "img/tech_image_7_2.df8e7fd3.jpg";